import React from 'react';
import { FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import { formatSum, formatClock } from '../../utils/formatters';

// Tashkilot va filial qarzi (AuditApteka asosiy bazasidan, /api/org-directory/debt).
// `compact` — telefon orolida bir-ikki qator; to'liq — mijoz kartasida.
//
// Manfiy balans = qarz, musbat = avans. Tashkilot qarzi — filiallar qarzining
// yig'indisi (bir filial avansi boshqasining qarzini yopmaydi).
export default function DebtInfo({ debt, compact = false }) {
  if (!debt || debt.branches_count === 0) return null;
  const b = debt.branch;
  const items = [];

  if (b) {
    if (b.balance === null) {
      items.push({ k: 'b', tone: 'muted', text: "Filial: qarz ma'lumoti yo'q" });
    } else if (b.debt > 0) {
      items.push({ k: 'b', tone: 'bad', text: `Filial qarzi: ${formatSum(b.debt)}` });
    } else if (b.advance > 0) {
      items.push({ k: 'b', tone: 'ok', text: `Filial avansi: ${formatSum(b.advance)}` });
    } else {
      items.push({ k: 'b', tone: 'ok', text: "Filialda qarz yo'q" });
    }
  }

  if (debt.with_balance === 0) {
    if (!b) items.push({ k: 'o', tone: 'muted', text: "Qarz ma'lumoti yo'q" });
  } else if (debt.total_debt > 0) {
    // Faqat shu filial qarzdor bo'lsa — bir xil summani ikki marta ko'rsatmaymiz.
    const onlyThis = b && b.debt > 0 && debt.debtor_branches === 1 && b.debt === debt.total_debt;
    if (!onlyThis) {
      items.push({
        k: 'o',
        tone: b ? 'warn' : 'bad',
        text: `${b ? 'Tashkilot jami' : 'Tashkilot qarzi'}: ${formatSum(debt.total_debt)} · ${debt.debtor_branches} filial`,
      });
    }
  } else if (!b) {
    items.push({ k: 'o', tone: 'ok', text: "Tashkilot bo'yicha qarz yo'q" });
  }

  if (!items.length) return null;

  return (
    <div className={`op2-debt${compact ? ' compact' : ''}`}>
      <div className="op2-debt-row">
        {items.map((it) => (
          <span key={it.k} className={`op2-debt-tag ${it.tone}`}>
            {it.tone === 'bad' || it.tone === 'warn' ? <FiAlertCircle size={12} /> : null}
            {it.tone === 'ok' ? <FiCheckCircle size={12} /> : null}
            {it.text}
          </span>
        ))}
        {debt.stale && <span className="op2-debt-note">eski ma'lumot</span>}
      </div>

      {!compact && debt.top_debtors && debt.top_debtors.length > 1 && (
        <div className="op2-debt-list">
          <div className="op2-quote-l" style={{ marginBottom: 6 }}>Eng ko'p qarzdor filiallar</div>
          {debt.top_debtors.map((x) => (
            <div key={x.userid} className={`op2-debt-li${b && x.userid === b.userid ? ' me' : ''}`}>
              <span className="nm">{x.name}{x.active ? '' : ' · bloklangan'}</span>
              <span className="sum">{formatSum(x.debt)}</span>
            </div>
          ))}
        </div>
      )}

      {!compact && debt.checked_at && (
        <div className="op2-debt-note" style={{ marginTop: 6 }}>
          AuditApteka bazasidan · {formatClock(debt.checked_at)} holatiga
        </div>
      )}
    </div>
  );
}
